module.exports = __webpack_public_path__ + "img/r8.3e8e8d35.jpg";